module.exports = __webpack_public_path__ + "img/23-op-ed-asian-development.532cf5d8.jpg";